import { render, staticRenderFns } from "./InventoryOnHandDetailModal.vue?vue&type=template&id=87ad5608&"
import script from "./InventoryOnHandDetailModal.vue?vue&type=script&lang=js&"
export * from "./InventoryOnHandDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports